<template>
    <div :style="valueBoxStyle" class="d-flex valueBox white--text pa-0 ma-0">

        <v-icon class="align-self-center pl-2 mb-1" :size="fontSize - 0.1 + 'em'" v-if="prefixIcon" :color="prefixIconColor">{{prefixIcon}}</v-icon>

        <div class="align-self-center pl-1 pr-1" :style="fontSize ? 'font-size: ' + fontSize + 'em' : ''">
            <span class="keepInline">{{prefix}}</span>
            {{ displayValue }}
            <span class="keepInline">{{postfix}}</span>
        </div>

        <v-icon v-if="postfixIcon" class="align-self-center pr-2 mb-1" :size="fontSize - 0.1 + 'em'" :color="postfixIconColor">{{postfixIcon}}</v-icon>

    </div>
</template>

<script>

    export default {

        components: {},

        props: {
            value: {
                type: Number | null,
                required: true,
                default: null
            },
            prefix: {
                type: String,
                required: false,
                default: ''
            },
            prefixIcon: {
                type: String,
                required: false,
                default: null,
            },
            prefixIconColor: {
                type: String,
                required: false,
                default: 'grey lighten-4'
            },
            postfix: {
                type: String,
                required: false,
                default: ''
            },
            postfixIcon: {
                type: String,
                required: false,
                default: ''
            },
            postfixIconColor: {
                type: String,
                required: false,
                default: 'grey lighten-4',
            },
            animate: {
                type: Boolean,
                required: false,
                default: true,
            },
            fontSize: {
                type: Number | null,
                required: false,
                default: null
            }
        },

        data() {
            return {
                boxValue: null,
                animationRunning: false,
                step: 1,
                diff: null,
                timer: null,
            }
        },

        computed: {
            displayValue() {
                if (this.boxValue !== null) {
                    return this.boxValue.toLocaleString();
                } else {
                    return "--";
                }
            },

            valueBoxStyle() {

                let styles = [];

                // styles.push('font-size: ' + this.fontSize + 'vw');
                // styles.push('line-height: ' + this.fontSize + 'vw');

                return styles.join(';') + ';';
            }
        },

        watch: {
            value(newCount, currentCount) {
                this.boxValue = currentCount;
                this.animateStart(newCount, currentCount);
            },
        },

        methods: {

            animateStart(newCount, currentCount) {
                // Prevent double animation
                if (!this.animationRunning && currentCount !== newCount) {

                    this.animationRunning = true;

                    // Count up
                    if (newCount > currentCount) {
                        this.diff = newCount - currentCount;
                        this.step = Math.floor(this.diff / 100);
                    } else {
                        this.diff = currentCount - newCount;
                        this.step = Math.floor(this.diff / 100) * -1;
                    }

                    this.timer = setInterval(() => {
                        this.boxValue += this.step;
                    }, 10);

                    setTimeout(() => {
                        clearInterval(this.timer);
                        this.boxValue = newCount;
                        this.animationRunning = false;
                    }, 1000);
                }
            },
        },

        // Seed initial value
        mounted() {
            if (this.animate) {
                this.boxValue = 0;
                if (this.value !== null) this.animateStart(this.value, 0);
            } else {
                this.boxValue = this.value;
            }
        }
    }
</script>

<style scoped>

.keepInline {
    display: inline;
    vertical-align: middle;
}

@media screen and (min-width: 320px) {
    .valueBox {
        font-size: 30px;
        line-height: 30px;
    }
}

@media screen and (min-width: 500px) {
    .valueBox {
        font-size: 35px;
        line-height: 35px;
    }
}

@media screen and (min-width: 1000px) {
    .valueBox {
        font-size: 40px;
        line-height: 40px;
    }
}

</style>